/* global _ */

export default {
  init() {
    // JavaScript to be fired on all pages

    // Sticky sidebar
    const hotelBookingSidebar = $('.hotel-booking-form-container.sidebar-wrapper');
    if (hotelBookingSidebar.length && $('html').is('.win,.gecko')) { // IE 11 only
      const sidebarPosTop = hotelBookingSidebar.offset().top - 100;
      const sidebarMaxPaddingTop = hotelBookingSidebar.parent().height();
      const throttleStickySidebar = _.throttle(function() {
        const scrollTop = $(document).scrollTop();
        if (scrollTop > sidebarPosTop) {
          hotelBookingSidebar.css('padding-top', Math.min(Math.max(0, scrollTop - sidebarPosTop), sidebarMaxPaddingTop) + 'px');
        } else {
          hotelBookingSidebar.css('padding-top', 0);
        }
      }, 10);
      $(window).bind('scroll', throttleStickySidebar);
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelGallery.js